import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { catchError, finalize } from 'rxjs/operators';
import { AuthStoreService } from 'src/app/shared/services/auth/auth-store.service';
import { AnalyticsFormService } from '../../../core/services/analytics-form.service';
import { ChangePasswordForm } from '../../forms/change-password.form';
import { verifyCodeErrorMessages } from '../../model/verify-code-error-messages';
import { HandsetService } from '../../../core/services/handset.service';
import { throwError } from 'rxjs';
import { LoaderButtonType } from '../../../shared/models/loader-button-type.enum';

@Component({
standalone: false,
  selector: 'app-change-password',
  styleUrls: ['./change-password.component.scss'],
  templateUrl: './change-password.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class ChangePasswordComponent implements OnInit {
  @Input() public loginUrl: string;
  @Input() public billtechPayMode: boolean;

  public changePasswordForm = new ChangePasswordForm();

  public loading: boolean;
  public errors: string[];
  public errorMessages = verifyCodeErrorMessages;
  public changed: boolean;
  public passwordVisible: boolean;
  public submitted = false;
  private email: string;

  public formName = 'changePassword';

  constructor(
    private authStore: AuthStoreService,
    private route: ActivatedRoute,
    private analyticsFormService: AnalyticsFormService,
    public handsetService: HandsetService,
  ) {
  }

  public ngOnInit(): void {
    const verificationCode = this.route.snapshot.paramMap.get('verificationCode');
    this.email = this.route.snapshot.queryParamMap.get('email');

    this.changePasswordForm.verificationState.setValue(verificationCode);
    this.changePasswordForm.email.setValue(this.email);
  }

  public onChangePassword(): void {
    if (this.changePasswordForm.valid) {
      this.loading = true;
      this.authStore
        .changePassword(this.changePasswordForm.value)
        .pipe(
          catchError((errors) => {
            this.errors = errors;
            this.changePasswordForm.verificationState.setErrors({});
            this.analyticsFormService.sendEventForCaughtError('verificationState', this.formName);
            return throwError(()=> errors)
          }),
          finalize(() => (this.loading = false)),
        )
        .subscribe(() => (this.changed = true));
    } else {
      this.submitted = true;
      this.analyticsFormService.sendEventForInvalidControls(this.changePasswordForm.controls, this.formName);
    }
  }

  public getQueryParams() {
    if (this.email) {
      return { email: this.email };
    }
    return {};
  }

  protected readonly LoaderButtonType = LoaderButtonType;
}
